export default function ProductOrderActions({
  onAdd,
  onGoToCart,
  hasSelectedQuantity,
  hasAddedItems,
  onClose
}) {
  return (
    <>
      {hasSelectedQuantity ? <button
        onClick={onAdd}
        className="bg-amber-600 text-white px-4 py-2 rounded-lg "
      >
        ثبت و ادامه
      </button> : (
        <button
          onClick={onClose}
          className="bg-amber-600/10 text-black border border-amber-700 px-4 py-2 rounded-lg"
        >
          ادامه
        </button>
      )}

      <button
        onClick={onGoToCart}
        disabled={!hasAddedItems}
        className="bg-[#2771371a]/10 text-darkgreen400 border border-[#2771371a]/30 hover:bg-[#277137] hover:text-white px-4 py-2 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
      >
        رفتن به سبد خرید
      </button>
    </>
  );
}